import { z } from 'zod';
import { SalesOrderItemType } from '../../../constants/sales-order-item-type.js';
import { MAX_ADJUSTMENT_LINES } from './max-adjustment-lines.js';
import { salesOrderAdjustmentLineInputSchema } from './sales-order-adjustment-line-input-schema.js';
import { duplicateSingleAdjustmentKinds } from './single-adjustment-kinds.js';
// One shipping, one discount, one TAX line per tax rate and at most one manual TAX line.
export const salesOrderAdjustmentLinesSchema = z
    .array(salesOrderAdjustmentLineInputSchema)
    .max(MAX_ADJUSTMENT_LINES, 'Too many adjustments.')
    .superRefine((lines, context) => {
    const seenTaxRateIds = new Set();
    let manualTaxSeen = false;
    lines.forEach((line, index) => {
        if (line.typeId === SalesOrderItemType.TAX) {
            if (line.taxRateId == null) {
                if (manualTaxSeen) {
                    context.addIssue({
                        code: 'custom',
                        message: 'Only one manual tax is allowed.',
                        path: [index, 'taxRateId'],
                    });
                }
                manualTaxSeen = true;
            }
            else {
                if (seenTaxRateIds.has(line.taxRateId)) {
                    context.addIssue({
                        code: 'custom',
                        message: 'Each tax rate can appear only once.',
                        path: [index, 'taxRateId'],
                    });
                }
                seenTaxRateIds.add(line.taxRateId);
            }
            return;
        }
    });
    for (const { index, typeId } of duplicateSingleAdjustmentKinds(lines.map((line) => line.typeId))) {
        const kind = typeId === SalesOrderItemType.SHIPPING ? 'Shipping' : 'Discount';
        context.addIssue({
            code: 'custom',
            message: `Only one ${kind} adjustment is allowed.`,
            path: [index, 'typeId'],
        });
    }
});
//# sourceMappingURL=sales-order-adjustment-lines-schema.js.map